import { ICreateProjetoInformacoesUseCase } from "../../../presentation/useCases/create/create_projeto_informacoes_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class CreateProjetoInformacoesUseCase implements ICreateProjetoInformacoesUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjetoInformacoes(        
  IdProjeto: number,   
  DescInformacoes: string | null,
  IdFuncionario: number | null,   
  Data: Date | null): Promise<void>{
    return await this.repository.createProjetoInformacoes(IdProjeto, DescInformacoes, IdFuncionario, Data);
  }
}
